import api from "../../../shared/api/apiClient";

export const aiApi = {
    async generateContactSummary(contactId) {
        const { data } = await api.post(`/ai/contacts/${contactId}/summary`);
        return data;
    },

    async generateEmailDraft(contactId, payload = {}) {
        const body = {
            tone: payload.tone || "professional",
            objective: payload.objective || payload.goal || "follow_up",
        };

        const { data } = await api.post(
            `/ai/contacts/${contactId}/email-draft`,
            body,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return data;
    },

    async generateNextStep(contactId) {
        const { data } = await api.post(`/ai/contacts/${contactId}/next-step`);
        return data;
    },

    async generateLeadScore(contactId) {
        const { data } = await api.post(`/ai/contacts/${contactId}/lead-score`);
        return data;
    },

    async analyzeContactActivity(contactId) {
        const { data } = await api.post(`/ai/contacts/${contactId}/activity-analysis`);
        return data;
    },

    async generateDealWorkAssistant(dealId) {
        const { data } = await api.post(`/ai/deals/${dealId}/assistant`);
        return data;
    }
};